import module from 'colaborador/module'

export const schema = {
  cajaAhorroId: 'number',
  maximoLimitePrestamo: 'number',
  totalPrestamo: 'number',
  interes: 'number',
  fechaInicial: 'date',
  fechaFinal: 'date',
  beneficiarioId: 'number',
  plazo: 'number',
}

export class ColaboradorCajaAhorroService {

  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, cajaAhorroId) {
    return this.$http.get('/api/colaborador/caja-ahorro', {
      params: {idProyecto, cajaAhorroId},
      schema,
    })
  }
}

module.service('ColaboradorCajaAhorro', ColaboradorCajaAhorroService)



// WEBPACK FOOTER //
// ./src/colaborador/services/Colaborador/CajaAhorro.js